import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { CatalogItem } from "../../../types";
import { unPublishCatalogItem } from "../../../redux/catalog";

export function useUnpublishCatalogPopup() {
    const dispatch = useDispatch();
    const [item, setItem] = useState<CatalogItem | null>(null);
    const [unpublishing, setUnpublishing] = useState(false);

    const openUnpublishConfirm = useCallback((catalogItem: CatalogItem) => {
        setItem(catalogItem);
    }, []);

    const closePopup = useCallback(() => {
        setItem(null);
    }, []);

    const onUnpublishConfirmCancel = useCallback(() => {
        if (unpublishing) {
            return;
        }
        closePopup();
    }, [closePopup, unpublishing]);

    const onUnpublishConfirm = useCallback(async () => {
        if (!item || unpublishing) {
            return;
        }

        setUnpublishing(true);
        const result = await dispatch(
            unPublishCatalogItem(item.item_id) as any,
        );
        setUnpublishing(false);

        if (unPublishCatalogItem.fulfilled.match(result)) {
            closePopup();
        }
    }, [closePopup, dispatch, item, unpublishing]);

    return {
        item,
        unpublishing,
        openUnpublishConfirm,
        closePopup,
        onUnpublishConfirmCancel,
        onUnpublishConfirm,
    };
}
